<div class="row">
  <div class="col-md-10 m-l no-print">
    <h2 class=" text-primary pageHeader " [ngClass]="breadcrumbTitleCssClass">
      <i [ngClass]="breadcrumb.cssIcon"></i>
      {{breadcrumb.title}} {{breadcrumb.subtitle}}
    </h2>
    <ol class="breadcrumb">
      <li>
        <span>{{supplierName||'No Supplier Name'}}</span>
      </li>
      <li *ngFor="let crumb of breadcrumb.crumbs;let index=index"  [ngClass]="{'active': (index === breadcrumb.crumbs.length - 1) }">
        <a *ngIf="crumb.goBack" (click)="goBack()"> {{ crumb.label || ('No Title for ' + index) }} </a>
        <span *ngIf="!crumb.goBack"> {{ crumb.label || ('No Title for ' + index) }} </span>
      </li>
      </ol>
  </div>
  <div class="col-md-2">
  </div>
</div>
